import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "app-button-form",
	templateUrl: "./button-form.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonFormComponent implements OnInit {
	@Input() firstNameButton: string;
	@Input() secondNameButton: string;
	@Input() thirdNameButton: string;
	@Output() eventFirstButton = new EventEmitter();
	@Input() disableFirstButton: boolean;
	@Output() eventSecondButton = new EventEmitter();
	@Output() eventThirdButton = new EventEmitter();
	@Input() disableThirdButton: boolean;

	constructor() {}

	ngOnInit() {}

	search(): void {
		this.eventFirstButton.emit();
	}

	resetForm(): void {
		this.eventSecondButton.emit();
	}

	thirdButtonClick(): void {
		this.eventThirdButton.emit();
	}
}
